(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capes-footer-plus"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('capes-newsletter-signup')) {
  customElements.define('capes-newsletter-signup', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const form = this.querySelector('form');
      if (!form) return;
      const email = form.querySelector('[type="email"]');
      const step = form.querySelector('[data-name-step]');
      const name = form.querySelector('[data-full-name]');
      const next = form.querySelector('[data-next-name]');
      step.hidden = true;
      name.disabled = true;
      const revealName = () => {
        if (!email.reportValidity()) return;
        step.hidden = false;
        name.disabled = false;
        name.focus();
      };
      next.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        revealName();
      }, options);
      email.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          revealName();
        }
      }, options);
      form.addEventListener('submit', event => {
        if (step.hidden || !email.checkValidity() || !name.value.trim()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (step.hidden) revealName();
          else {
            name.setCustomValidity(name.value.trim() ? '' : name.placeholder);
            form.reportValidity();
          }
        }
      }, { ...options, capture: true });
      name.addEventListener('input', () => name.setCustomValidity(''), options);
      form.addEventListener('formdata', event => {
        const parts = name.value.trim().split(/\s+/);
        event.formData.set('contact[first_name]', parts.shift() || '');
        event.formData.set('contact[last_name]', parts.join(' '));
      }, options);
      if (/^#(?:capes-pr|CapesPrForm-|CapesPrEmail-)/.test(window.location.hash)) {
        const message = this.querySelector('.footer-plus-form-message[role="status"]');
        if (message) message.hidden = true;
      }
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capes-next-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
 const observers = new Map();
 const mobile = matchMedia('(max-width:749px)');
 const reduced = matchMedia('(prefers-reduced-motion:reduce)');
 const init = (root) => {
  root.querySelectorAll('.capes-peek-item--tooth[data-peek-wiggle-scroll="true"]').forEach(item => {
   if (observers.has(item)) return;
   let entered = false;
   const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
     if (!entry.isIntersecting) { entered = false; return; }
     if (entry.intersectionRatio < .3 || entered) return;
     entered = true;
     if (mobile.matches && !reduced.matches) item.classList.add('is-peek-wiggling');
    });
   }, {threshold:[0,.3]});
   const finish = () => item.classList.remove('is-peek-wiggling');
   item.addEventListener('animationend', finish);
   observer.observe(item);
   observers.set(item, {observer, finish});
  });
 };
 const cleanup = root => {
  observers.forEach((state,item) => {
   if (!root.contains(item)) return;
   state.observer.disconnect();
   item.removeEventListener('animationend',state.finish);
   observers.delete(item);
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
 else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>cleanup(event.target));
})();

(() => {
 const active = new Map();
 const reduced = matchMedia('(prefers-reduced-motion:reduce)');
 const init = root => {
  root.querySelectorAll('[data-peek-typing="true"]').forEach(heading => {
   if (active.has(heading)) return;
   const original = heading.textContent;
   const match = original.match(/\b(?:obsession|absession|abcession)\b/i);
   if (!match) return;
   const words = [heading.dataset.wordOne || 'obsession',heading.dataset.wordTwo || 'Abcession'].map(word=>Array.from(word));
   const readNumber = (key,fallback) => Math.max(20,Number(heading.dataset[key]) || fallback);
   const typeSpeed = readNumber('typeSpeed',120);
   const deleteSpeed = readNumber('deleteSpeed',70);
   const wordPause = readNumber('wordPause',1400);
   const emptyPause = readNumber('emptyPause',350);
   const prefix = original.slice(0,match.index), suffix = original.slice(match.index+match[0].length);
   heading.setAttribute('aria-label',prefix+words[0].join('')+suffix);
   const text = document.createElement('span');
   text.setAttribute('aria-hidden','true');
   text.append(document.createTextNode(prefix));
   const frame = document.createElement('span');
   frame.className = 'capes-peek-type-word';
   words.forEach(word => {
    const measure = document.createElement('span');
    measure.className = 'capes-peek-type-measure';
    measure.textContent = word.join('');
    frame.append(measure);
   });
   const live = document.createElement('span');
   live.className = 'capes-peek-type-live';
   const letters = document.createElement('span');
   letters.className = 'capes-peek-typed';
   const cursor = document.createElement('span');
   cursor.className = 'capes-peek-cursor';
   live.append(letters,cursor);
   frame.append(live);
   text.append(frame,document.createTextNode(suffix));
   heading.replaceChildren(text);
   let timer = null, visible = false, index = 0, count = 0, phase = 'type';
   const cancel = () => { clearTimeout(timer); timer = null; };
   const schedule = delay => {
    cancel();
    if (visible && !document.hidden && !reduced.matches) timer = setTimeout(step,delay);
   };
   const render = () => { letters.textContent = words[index].slice(0,count).join(''); };
   function step() {
    timer = null;
    if (!visible || document.hidden || reduced.matches) return;
    if (phase === 'type') {
     count++; render();
     if (count >= words[index].length) {phase = 'delete';schedule(wordPause);}
     else schedule(typeSpeed);
    } else {
     count--; render();
     if (count <= 0) {index = (index+1)%words.length;phase = 'type';schedule(emptyPause);}
     else schedule(deleteSpeed);
    }
   }
   const sync = () => {
    cancel();
    if (reduced.matches) {letters.textContent=words[0].join('');return;}
    render();
    schedule(typeSpeed);
   };
   const observer = new IntersectionObserver(entries => {
    visible = entries.some(entry=>entry.isIntersecting);
    sync();
   },{threshold:0});
   const onVisibility = () => {if(document.hidden) cancel();else sync();};
   reduced.addEventListener('change',sync);
   document.addEventListener('visibilitychange',onVisibility);
   observer.observe(heading);
   if (reduced.matches) letters.textContent=words[0].join('');
   active.set(heading,{observer,cancel,sync,onVisibility});
  });
 };
 const cleanup = root => {
  active.forEach((state,heading) => {
   if (!root.contains(heading)) return;
   state.cancel();state.observer.disconnect();
   reduced.removeEventListener('change',state.sync);
   document.removeEventListener('visibilitychange',state.onVisibility);
   active.delete(heading);
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
 else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>cleanup(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capes-pr-drawing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    root.querySelectorAll('.capes-pr').forEach(section => {
      if (section.dataset.prInitialized) return;
      section.dataset.prInitialized = 'true';
      const form = section.querySelector('.capes-pr__form');
      const position = form?.querySelector('[data-pr-position]');
      const otherField = form?.querySelector('[data-pr-other-field]');
      const otherInput = form?.querySelector('[data-pr-other-position]');
      const tags = form?.querySelector('[data-pr-tags]');
      if (position && otherField && otherInput && tags) {
        const clean = value => value.trim().replace(/[,\r\n]+/g, ' ').slice(0, 80);
        const updateTags = () => {
          const firstName = form.elements.namedItem('contact[first_name]');
          const lastName = form.elements.namedItem('contact[last_name]');
          const values = ['newsletter', 'capes-pr-drawing'];
          if (position.value) values.push('PR position: ' + position.value);
          if (position.value === 'Other' && clean(otherInput.value)) values.push('PR other position: ' + clean(otherInput.value));
          if (firstName && clean(firstName.value)) values.push('PR first name: ' + clean(firstName.value));
          if (lastName && clean(lastName.value)) values.push('PR last name: ' + clean(lastName.value));
          const platform = form.querySelector('[data-pr-social-platform]');
          const handle = form.querySelector('[data-pr-social-handle]');
          if (platform?.value) values.push('PR social platform: ' + platform.value);
          if (platform?.value && clean(handle?.value || '')) values.push('PR social handle: ' + platform.value + ' ' + clean(handle.value));
          form.querySelectorAll('[data-pr-follow]:checked').forEach(box => values.push('PR follow reported: ' + box.value));
          const collab = form.querySelector('[data-pr-collab]');
          if (collab?.value === 'yes') values.push('PR collaboration: Yes', 'capes-collab-interest');
          if (collab?.value === 'pr-only') values.push('PR collaboration: No - just PR', 'capes-pr-only');
          tags.value = values.join(',');
        };
        const updatePosition = () => {
          const isOther = position.value === 'Other';
          otherField.hidden = !isOther;
          otherInput.disabled = !isOther;
          otherInput.required = isOther;
          updateTags();
        };
        const followBoxes = [...form.querySelectorAll('[data-pr-follow]')];
        const followError = form.querySelector('[data-pr-follow-error]');
        const submitButton = form.querySelector('.capes-pr__submit');
        const hasFollow = () => followBoxes.some(box => box.checked);
        const updateFollowValidity = () => {
          const valid = hasFollow();
          if (followBoxes[0]) followBoxes[0].setCustomValidity(valid ? '' : followError.textContent.trim());
          if (valid) followError.hidden = true;
          followBoxes.forEach(box => box.removeAttribute('aria-invalid'));
          return valid;
        };
        const showFollowError = () => {
          followError.hidden = false;
          followBoxes.forEach(box => box.setAttribute('aria-invalid', 'true'));
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && submitButton.animate) {
            submitButton.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' }, { transform: 'translateX(7px)' }, { transform: 'translateX(-5px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }], { duration: 380, easing: 'ease-in-out' });
          }
          followBoxes[0]?.focus({ preventScroll: true });
        };
        followBoxes.forEach(box => box.addEventListener('change', () => { updateFollowValidity(); updateTags(); }));
        submitButton.addEventListener('click', event => {
          if (!updateFollowValidity()) { event.preventDefault(); showFollowError(); }
        });
        form.addEventListener('submit', event => {
          if (!updateFollowValidity()) { event.preventDefault(); showFollowError(); }
        });
        if (followBoxes[0]) followBoxes[0].addEventListener('invalid', showFollowError);
        form.addEventListener('reset', () => requestAnimationFrame(() => { updateFollowValidity(); followError.hidden = true; }));
        updateFollowValidity();
        position.addEventListener('change', updatePosition);
        form.addEventListener('input', updateTags);
        form.addEventListener('change', updateTags);
        form.addEventListener('submit', updateTags);
        form.addEventListener('reset', () => requestAnimationFrame(updatePosition));
        updatePosition();
      }
      if (section.dataset.prMotion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      const elements = [...section.querySelectorAll('[data-pr-reveal]')];
      const observer = new IntersectionObserver(entries => {
        entries.filter(entry => entry.isIntersecting).sort((a, b) => elements.indexOf(a.target) - elements.indexOf(b.target)).forEach((entry, index) => {
          entry.target.style.setProperty('--pr-delay', `${Math.min(index, 8) * 90}ms`);
          entry.target.classList.add('capes-pr--revealed');
          observer.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -5% 0px' });
      section.classList.add('capes-pr--motion-ready');
      elements.forEach(element => observer.observe(element));
    });
  };
  init(document);
  const revealPrSection = () => {
    if (!/^#(?:capes-pr|CapesPrForm-|CapesPrEmail-)/.test(window.location.hash)) return;
    const section = document.querySelector('.capes-pr');
    const confirmation = section?.querySelector('.capes-pr__success');
    if (confirmation) confirmation.scrollIntoView({ block: 'center', behavior: 'instant' });
    else if (section) section.scrollIntoView({ block: 'start', behavior: 'instant' });
  };
  window.addEventListener('hashchange', revealPrSection);
  if (document.readyState === 'complete') requestAnimationFrame(revealPrSection);
  else window.addEventListener('load', revealPrSection, { once: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capes-testimony-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('capes-testimony')) {
 customElements.define('capes-testimony',class extends HTMLElement {
  connectedCallback() {
   this.abort=new AbortController();this.rows=new Map();this.inView=true;
   this.desktop=matchMedia('(min-width:750px) and (prefers-reduced-motion:no-preference)');
   this.rebuild=()=>this.build();this.desktop.addEventListener('change',this.rebuild);
   const signal=this.abort.signal;
   this.querySelectorAll('.tm-row').forEach(row=>{
    row.addEventListener('mouseenter',()=>{const state=this.rows.get(row);if(state){state.hover=true;this.sync(state);}},{signal});
    row.addEventListener('mouseleave',()=>{const state=this.rows.get(row);if(state){state.hover=false;this.sync(state);}},{signal});
    row.addEventListener('focusin',()=>{const state=this.rows.get(row);if(state){state.focus=true;this.sync(state);}},{signal});
    row.addEventListener('focusout',()=>queueMicrotask(()=>{const state=this.rows.get(row);if(state){state.focus=row.contains(document.activeElement);this.sync(state);}}),{signal});
    row.addEventListener('wheel',event=>{
     const state=this.rows.get(row);
     if(!state || !this.desktop.matches)return;
     let delta=event.deltaX;
     if(event.shiftKey && Math.abs(event.deltaY)>Math.abs(delta))delta=event.deltaY;
     if(Math.abs(delta)<.5)return;
     if(event.deltaMode===1)delta*=16;
     if(event.deltaMode===2)delta*=row.clientWidth;
     event.preventDefault();this.move(state,delta);
    },{passive:false,signal});
    row.addEventListener('keydown',event=>{
     const state=this.rows.get(row);
     if(!state || !['ArrowLeft','ArrowRight'].includes(event.key))return;
     event.preventDefault();this.move(state,event.key==='ArrowRight'?80:-80);
    },{signal});
   });
   this.addEventListener('shopify:block:select',event=>{
    this.editing=true;this.rows.forEach(state=>this.sync(state));
    const row=event.target.closest('.tm-row'),state=this.rows.get(row);
    if(state){
     const card=event.target.closest('.tm-card');
     if(card){const offset=card.offsetLeft%state.width;state.animation.currentTime=(state.reverse?1-offset/state.width:offset/state.width)*state.duration;}
    }
   },{signal});
   this.addEventListener('shopify:block:deselect',()=>{this.editing=false;this.rows.forEach(state=>this.sync(state));},{signal});
   document.addEventListener('visibilitychange',()=>this.rows.forEach(state=>this.sync(state)),{signal});
   this.visibleObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.rows.forEach(state=>this.sync(state));});
   this.visibleObserver.observe(this);
   this.lastWidth=0;
   this.resizeObserver=new ResizeObserver(entries=>{
    const width=Math.round(entries[0].contentRect.width);
    if(width!==this.lastWidth){this.lastWidth=width;this.build();}
   });
   this.resizeObserver.observe(this);this.build();
  }
  sync(state){
   if(state.hover || state.focus || this.editing || !this.inView || document.hidden)state.animation.pause();
   else state.animation.play();
  }
  move(state,delta){
   const current=Number(state.animation.currentTime)||0;
   const next=current+(state.reverse?-1:1)*delta/state.width*state.duration;
   state.animation.currentTime=((next%state.duration)+state.duration)%state.duration;
   this.sync(state);
  }
  build(){
   const phases=new Map();
   this.rows.forEach((state,row)=>{phases.set(row,((Number(state.animation.currentTime)||0)%state.duration)/state.duration);state.animation.cancel();});
   this.rows.clear();this.classList.remove('tm-ready');
   this.querySelectorAll('[data-tm-clone]').forEach(e=>e.remove());
   const animate=this.desktop.matches && this.dataset.autoplay==='true';
   this.querySelectorAll('.tm-row').forEach(row=>{
    const track=row.querySelector('.tm-track'),group=track.querySelector('.tm-group');
    track.style.animation='';track.style.transform='';row.hidden=!group.children.length;
    if(!animate || row.hidden)return;
    row.scrollLeft=0;
    const width=group.getBoundingClientRect().width;
    if(!width)return;
    for(let i=0;i<Math.ceil(row.clientWidth/width)+1;i++){
     const clone=group.cloneNode(true);clone.dataset.tmClone='true';clone.setAttribute('aria-hidden','true');
     clone.querySelectorAll('[data-shopify-editor-block]').forEach(e=>e.removeAttribute('data-shopify-editor-block'));
     clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(e=>e.setAttribute('tabindex','-1'));
     track.append(clone);
    }
    const duration=(parseFloat(getComputedStyle(this).getPropertyValue('--tm-duration'))||45)*1000;
    const reverse=row.dataset.row==='1';
    const frames=[{transform:'translateX(0px)'},{transform:'translateX(-'+width+'px)'}];
    if(reverse)frames.reverse();
    const animation=track.animate(frames,{duration,iterations:Infinity,easing:'linear'});
    animation.currentTime=(phases.get(row)||0)*duration;
    const state={animation,duration,width,reverse,hover:row.matches(':hover'),focus:row.contains(document.activeElement)};
    this.rows.set(row,state);this.sync(state);
   });
   this.classList.toggle('tm-ready',animate);
  }
  disconnectedCallback(){
   this.abort?.abort();this.visibleObserver?.disconnect();this.resizeObserver?.disconnect();
   this.desktop?.removeEventListener('change',this.rebuild);
   this.rows?.forEach(state=>state.animation.cancel());
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capes-trivia"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('capes-trivia')) customElements.define('capes-trivia',class extends HTMLElement{
 connectedCallback(){
  this.classList.add('tv-ready');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches||this.dataset.motion==='false';
  const reveal=q=>{q.classList.add('tv-revealed');q.querySelectorAll('.tv-option').forEach(b=>b.setAttribute('aria-expanded','true'));};
  this.abort=new AbortController();
  this.addEventListener('click',e=>{const b=e.target.closest('.tv-option');if(b)reveal(b.closest('.tv-question'));},{signal:this.abort.signal});
  this.addEventListener('shopify:block:select',e=>{const q=e.target.closest('.tv-question');if(q)reveal(q);},{signal:this.abort.signal});
  if(reduced||!('IntersectionObserver' in window)){this.querySelectorAll('.tv-question').forEach(reveal);}else{
   this.observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){reveal(e.target);this.observer.unobserve(e.target);}}),{rootMargin:'0px 0px -24% 0px',threshold:.25});
   this.querySelectorAll('.tv-question').forEach(q=>this.observer.observe(q));
  }
  const video=this.querySelector('video');if(video&&!reduced){this.videoObserver=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)video.play().catch(()=>{});else video.pause();}),{threshold:.1});this.videoObserver.observe(video);}
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.videoObserver?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('capes-hero-slides')) {
    customElements.define('capes-hero-slides', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('[data-capes-slide]'));
        this.index = 0;
        this.hasSelected = false;
        this.effects = [];
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.navigation = this.querySelector('.capes-hero-navigation');
        this.navigation.hidden = this.slides.length < 2;
        this.dots = Array.from(this.querySelectorAll('[data-slide-index]'));
        this.originalCopy = this.querySelector('[data-original-copy]');
        this.toggle = this.querySelector('[data-slide-toggle]');
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.explicitPlay = false;
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) { this.paused = true; this.explicitPlay = false; this.cancelEffects(); }
          this.syncMedia();
        }, options);
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (button?.hasAttribute('data-slide-prev')) this.select(this.index - 1);
          if (button?.hasAttribute('data-slide-next')) this.select(this.index + 1);
          if (button?.hasAttribute('data-slide-toggle')) {
            this.paused = !this.paused;
            this.explicitPlay = !this.paused;
            this.syncMedia();
          }
          if (button?.hasAttribute('data-slide-index')) this.select(Number(button.dataset.slideIndex));
        }, options);
        this.addEventListener('touchstart', event => {
          if (event.touches.length !== 1 || event.target.closest('button,a')) return;
          this.touch = [event.touches[0].clientX, event.touches[0].clientY];
        }, { ...options, passive:true });
        this.addEventListener('touchend', event => {
          if (!this.touch) return;
          const dx = event.changedTouches[0].clientX - this.touch[0];
          const dy = event.changedTouches[0].clientY - this.touch[1];
          this.touch = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + (dx < 0 ? 1 : -1));
        }, { ...options, passive:true });
        this.addEventListener('video:play', event => {
          if (event.target.closest('[data-capes-slide]') !== this.slides[this.index] || this.paused || document.hidden) event.target.pause?.();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editorSelected = true; this.select(index); }
          else if (this.originalCopy?.contains(event.target)) this.select(0);
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.syncMedia(), options);
        window.addEventListener('resize', () => this.syncMedia(), options);
        if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncMedia();
        });
        this.observer.observe(this);
        }
        this.select(0);
      }
      select(index) {
        if (!this.slides.length) return;
        const next = (index + this.slides.length) % this.slides.length;
        const changed = this.hasSelected && next !== this.index;
        this.cancelEffects();
        const outgoing = changed && !this.reduced.matches && this.dataset.transition !== 'none' ? this.slides[this.index] : null;
        if (outgoing) outgoing.setAttribute('data-capes-leaving', '');
        this.index = next;
        this.hasSelected = true;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          if (!slide.hasAttribute('data-original-slide')) slide.hidden = !active && slide !== outgoing;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        if (this.originalCopy) {
          this.originalCopy.hidden = this.index !== 0;
          this.originalCopy.inert = this.index !== 0;
        }
        const defaults = this.slides[0].dataset;
        const current = this.slides[this.index].dataset;
        const overlay = current.overlayCustom === 'true' ? current : defaults;
        this.style.setProperty('--capes-overlay-desktop', overlay.overlayDesktop ?? defaults.overlayDesktop);
        this.style.setProperty('--capes-overlay-mobile', overlay.overlayMobile ?? defaults.overlayMobile);
        this.syncMedia();
        if (changed && !this.reduced.matches) this.animateSelection(outgoing);
      }
      cancelEffects() {
        (this.effects || []).forEach(effect => effect.cancel());
        this.effects = [];
        this.finishTransition?.();
        this.finishTransition = null;
      }
      animateSelection(outgoing) {
        const duration = Number(this.dataset.transitionDuration) || 600;
        const incoming = this.slides[this.index];
        const media = slide => Array.from(slide.querySelectorAll(':scope > video-media, :scope > .deferred-media, :scope > .capes-slide-desktop-video, :scope > .capes-slide-mobile-video, :scope > picture')).filter(el => el.getClientRects().length);
        const animate = (el, frames, options) => {
          if (typeof el.animate !== 'function') return null;
          const effect = el.animate(frames, options);
          this.effects.push(effect);
          return effect;
        };
        const finished = [];
        if (this.dataset.transition !== 'none') {
          const shift = this.dataset.transition === 'slide';
          const options = { duration, easing:'cubic-bezier(.22,.61,.36,1)' };
          media(incoming).forEach(el => {
            const effect = animate(el, [{ opacity:0, transform:shift ? 'translateX(32px)' : 'none' }, { opacity:1, transform:'none' }], options);
            if (effect) finished.push(effect.finished.catch(() => {}));
          });
          if (outgoing) media(outgoing).forEach(el => {
            const effect = animate(el, [{ opacity:1, transform:'none' }, { opacity:0, transform:shift ? 'translateX(-16px)' : 'none' }], { ...options, fill:'forwards' });
            if (effect) finished.push(effect.finished.catch(() => {}));
          });
        }
        const cleanup = () => {
          if (!outgoing) return;
          outgoing.removeAttribute('data-capes-leaving');
          if (!outgoing.hasAttribute('data-original-slide')) outgoing.hidden = outgoing !== this.slides[this.index];
        };
        this.finishTransition = cleanup;
        Promise.all(finished).then(() => {
          if (this.finishTransition !== cleanup) return;
          cleanup();
          this.finishTransition = null;
        });
        if (this.dataset.textAnimation === 'none') return;
        const copy = this.index === 0 ? this.originalCopy : incoming;
        if (!copy) return;
        const items = Array.from(copy.querySelectorAll('.banner__box > *')).filter(el => el.getClientRects().length > 0 && getComputedStyle(el).display !== 'none');
        items.forEach((el, i) => animate(el, [
          { opacity:0, translate:this.dataset.textAnimation === 'rise' ? '0 22px' : '0 0' },
          { opacity:1, translate:'0 0' }
        ], { duration:Number(this.dataset.textDuration) || 700, delay:100 + i * (Number(this.dataset.textStagger) || 0), easing:'cubic-bezier(.22,.61,.36,1)', fill:'backwards' }));
      }
      syncMedia(explicit = false) {
        this.schedule();
        const active = this.slides[this.index];
        const canPlay = !this.paused && !document.hidden && this.inView !== false && (!this.reduced.matches || explicit || this.explicitPlay);
        this.slides.forEach(slide => {
          slide.querySelectorAll('video-media').forEach(media => {
            const play = slide === active && canPlay && media.getClientRects().length > 0 && media.hasAttribute('autoplay');
            media.paused = !play;
            if (play) media.play?.(); else media.pause?.();
          });
          slide.querySelectorAll('video').forEach(video => {
            if (video.closest('video-media')) return;
            if (slide === active && canPlay && video.getClientRects().length > 0) video.play().catch(() => {}); else video.pause();
          });
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.toggle) {
          this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
          this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        }
        if (this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden || this.inView === false) return;
        this.timer = setTimeout(() => this.select(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 8000));
      }
      disconnectedCallback() {
        this.cancelEffects();
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
